import React, { useState, useCallback, useEffect } from "react";
import { RoutePath, BadgeStatus, DATE_FORMAT, EntityType, IAppUserProfile } from "shared/constants";
import { useNavigate } from "react-router-dom";
import NoDataFound from "components/NoDataFound";
import { useTranslation } from "react-i18next";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import { useDispatch } from "react-redux";
import { requestPending, requestPristine, /*requestSuccess, requestError*/ } from "state/reducer/requestStatusSlice";
import { getTransports } from "net/contracts";
import moment from "moment";
import TableRighArrow from "components/TableRightArrow";
import DsBadge from "components/DsBadge";
import AddEntityButton from "components/AddEntityButton";
import useAppUser from "hooks/useAppUser";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { Table } from "@ds/ds-snam/react";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple } from "shared/utils/dsComponentUtils";

interface ITransportElement {
    transporterId: string,
    businessName: string,
    lastUpdateTimestamp: number,
    status: number,
    businessSecondName:string, //new
    firstName:string, //new
    secondName:string, //new
    email:string, //new
    businessState:string, //new
    delegationStatus:number
}
const TransportList: React.FC<{}> = (props) => {

    const [transportList, setTransportList] = useState<ITransportElement[]>([]);
    const [transportListFiltered,setTransportListFiltered] = useState<ITransportElement[]>([]);
    const [filters, setFilters] = useState<{ [key: string]: string }>({
            col1: "",
            col2: "",
            col3: "",
            col4: "",
            col5: "",
        });
    const navigate = useNavigate();
    const { t } = useTranslation(['contract', 'app']);
    const dispatch = useDispatch();

    const appUserProfile:IAppUserProfile | undefined = useAppUser()?.userProfile;


    const loadData = useCallback(() => {
        dispatch(requestPending());
        getTransports()
            .then((response: any) => {
                setTransportListFiltered(response.data);
                setTransportList(response.data);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }, [dispatch]);

    const getBadgeStatus = (status: BadgeStatus, isSmall?: boolean) => {
        let notificationStatus = ''
        if (status === BadgeStatus.EXPIRED || status === BadgeStatus.NOTAPPROVED) {
            notificationStatus = 'error'
        } else if (status === BadgeStatus.TOAPPROVE) {
            notificationStatus = 'warning'
        } else if (status === BadgeStatus.APPROVED) {
            notificationStatus = 'confirm'
        }
        return notificationStatus;

    }
    useEffect(() => {
        loadData();
        return () => {
            dispatch(requestPristine());
        }
    }, [loadData, dispatch]);

    const tableCols = (() => {
        //return ["Trasportatore", "Data ultima modifica", ""];
        //return t("transporter.transporterList.tableColumns", { ns: 'contract', returnObjects: true }) as string[];
        return [
            t("transporter.transporterList.tableColumns.0", { ns: 'contract'}) as string,
            t("transporter.transporterList.tableColumns.1", { ns: 'contract'}) as string,
            t("transporter.transporterList.tableColumns.2", { ns: 'contract'}) as string,
            t("transporter.transporterList.tableColumns.3", { ns: 'contract'}) as string,
            t("transporter.transporterList.tableColumns.4", { ns: 'contract'}) as string,
            t("transporter.transporterList.tableColumns.5", { ns: 'contract'}) as string,
            t("transporter.transporterList.tableColumns.6", { ns: 'contract'}) as string
        ];
    })();

    const tableRows = transportListFiltered.map((transport: ITransportElement, index) => {
        return (
            <tr key={transport.transporterId}>
                <td>
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <DsBadge notificationStatus={getBadgeStatus(transport.status)} />
                        {transport.businessName}
                    </span>
                </td>
                <td>{transport.businessSecondName}</td>
                <td>{transport.firstName + " " + transport.secondName}</td>
                <td>{transport.email}</td>
                <td>{transport.businessState}</td>
                <td>{parseDateForDS(moment.unix(transport.lastUpdateTimestamp).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}</td>
                <td>
                    <TableRighArrow onClick={() => {
                        navigate(transport.transporterId);
                    }} />
                </td>
            </tr>
        )
    });

    const getTransportListSearchColumns = (index: number) => {
        return index === 0 || index === 1 || index === 2 || index === 3 || index === 4 || index === 5;
    };
    // Gestione dei cambiamenti dei filtri
    const handleFilterChange = (columnKey: string, value: string) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [columnKey]: value,
        }));
    };

    /**FILTER */
    useEffect(()=>{
        let myFilteredList:ITransportElement[] = [];
        for(let i in transportList){
            if(
                transportList[i].businessName.toLocaleLowerCase().includes(filters.col1.toLocaleLowerCase()) &&
                transportList[i].businessSecondName.toLocaleLowerCase().includes(filters.col2.toLocaleLowerCase()) &&
                (transportList[i].firstName.toLocaleLowerCase().includes(filters.col3.toLocaleLowerCase()) ||transportList[i].secondName.toLocaleLowerCase().includes(filters.col3.toLocaleLowerCase())) &&
                transportList[i].email.toLocaleLowerCase().includes(filters.col4.toLocaleLowerCase()) &&
                transportList[i].businessState.toLocaleLowerCase().includes(filters.col5.toLocaleLowerCase())
            ){
                myFilteredList.push(transportList[i]);
            }
        }
        setTransportListFiltered(myFilteredList);
    },[filters])

    const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | null>(null);

    const handleSortColumn5 = () => {
        if (sortOrder === null) {
            // Se non c'è un ordine predefinito, inizia ordinando in ordine crescente.
            const sortedList = [...transportListFiltered].sort((a, b) => {
                const dateA = moment.unix(a.lastUpdateTimestamp);
                const dateB = moment.unix(b.lastUpdateTimestamp);
                return dateA.diff(dateB); // Ordinamento crescente
            });
            setTransportListFiltered(sortedList);
            setSortOrder('desc');
        } else {
            // Se c'è un ordine, alterna tra crescente e decrescente
            const sortedList = [...transportListFiltered].sort((a, b) => {
                const dateA = moment.unix(a.lastUpdateTimestamp);
                const dateB = moment.unix(b.lastUpdateTimestamp);
                return sortOrder === 'asc' ? dateA.diff(dateB) : dateB.diff(dateA);
            });
            setTransportListFiltered(sortedList);
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        }
    };

    const getTableRowsTransport = (): ITableRow[] => {
                  let myRetArr: ITableRow[] = [];
                  for (let i in transportListFiltered) {
                      let tempObj: ITableRow = {
                          tableCells: [
                              { 
                                  type: "text-badge", 
                                  text: transportListFiltered[i].businessName,
                                  badgeStatus: transportListFiltered[i].status === 3 ?"confirm":
                                  ( transportListFiltered[i].status===2?
                                    "warning":
                                    "error"
                                  )
                              },
                              { 
                                  type: "text", 
                                  text: transportListFiltered[i].businessSecondName,
                              },
                              { 
                                  type: "text", 
                                  text: transportListFiltered[i].firstName + " " + transportListFiltered[i].secondName,
                              },
                              { 
                                  type: "text", 
                                  text: transportListFiltered[i].email,
                              },
                              { 
                                  type: "text", 
                                  text: transportListFiltered[i].businessState,
                              },
                              transportListFiltered[i].delegationStatus === -1 ?
                                { 
                                    type: "text", 
                                    text: "",
                                }
                              :
                                {
                                        type: "text-badge", 
                                        text: "",
                                        badgeStatus: transportListFiltered[i].delegationStatus === 3 ?"confirm":
                                        ( transportListFiltered[i].delegationStatus===2?
                                            "warning":
                                            "error"
                                        )
                                }
                            ,
                              { 
                                  type: "text", 
                                  text: parseDateForDS(moment.unix(transportListFiltered[i].lastUpdateTimestamp).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1),
                              },
                          ],
                          rightIcon: "icon-chevron-right",
                      };
                      myRetArr.push(tempObj);
                  }
                  return myRetArr;
          };

    const myTableConfigTransport: ITableConfig = {
                  ...getDSTableSharedElements(560),
                  tableHeader: {
                      
                      tableCellsHeader: [
                          {
                            ...getDSTableShaderElementsForFilterColumn(t("transporter.transporterList.tableColumns.0", { ns: 'contract'}) as string,"col1","20%","Annulla","Conferma",t('general.buttons.search', { ns: 'app' })),
                            searchBoxValue:filters["col1"], //<---
                          },
                          {
                            ...getDSTableShaderElementsForFilterColumn(t("transporter.transporterList.tableColumns.1", { ns: 'contract'}) as string,"col2","14%","Annulla","Conferma",t('general.buttons.search', { ns: 'app' })),
                              searchBoxValue:filters["col2"], //<---
                          },
                          {
                            ...getDSTableShaderElementsForFilterColumn(t("transporter.transporterList.tableColumns.2", { ns: 'contract'}) as string,"col3","16%","Annulla","Conferma",t('general.buttons.search', { ns: 'app' })),
                              searchBoxValue:filters["col3"], //<---
                          },
                          {
                            ...getDSTableShaderElementsForFilterColumn(t("transporter.transporterList.tableColumns.3", { ns: 'contract'}) as string,"col4","16%","Annulla","Conferma",t('general.buttons.search', { ns: 'app' })),
                              searchBoxValue:filters["col4"], //<---
                          },
                          getTableCellsHeaderSimple(t("transporter.transporterList.tableColumns.4", { ns: 'contract'}) as string,"col5","8%","left"),
                          getTableCellsHeaderSimple(t("transporter.transporterList.tableColumns.7", { ns: 'contract'}) as string,"col6","10%","left"),
                          getTableCellsHeaderSimple(t("transporter.transporterList.tableColumns.5", { ns: 'contract'}) as string,"col7","16%","left",true),
                      ],
                      hasSearchBox: true,
                  },
                  tableRows: getTableRowsTransport(),
              };

    return (
        <div>
            <p className="pageTitle" style={{ marginBottom: "10px" }}>
                {t('transporter.transporterList.title')}
            </p>
            {/*<p className="pageSubTitle">
                {t('transporter.transporterList.subTitle')}
            </p>*/}
            

            {appUserProfile?.addEntityPolicy.includes(EntityType.TRANSPORTER)&&
                <div style={{ marginTop: "28px", marginBottom: "14px", display: "flex", alignItems: "flex-start", justifyContent: "flex-end", gap:"15px" }}>
                    <AddEntityButton entityType={EntityType.TRANSPORTER} />
                    <AddEntityButton entityType={EntityType.TRANSPORTERDELEGATION}/>
                </div>
            }
            
            {transportList && transportList.length ?
                <>
                    
                    <div className="listTableContainer">
                    {
                       <Table 
                            tableConfig={myTableConfigTransport} 
                            style={{}}
                            onInputSearchBarChange={(event:Event)=>{
                                console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                            }}
                           //FILTERS
                            onClickRightAction={(event:Event)=>{
                                //console.log(event)
                                navigate(transportListFiltered[(event as CustomEvent).detail.row].transporterId);
                            }}
                            onSubmitSearchedText={(event:Event)=>{
                                const focusColtemp = (event as CustomEvent).detail.cells;
                                let focusCol = '';
                                switch (focusColtemp) {
                                    case 0:
                                        focusCol = "col1";
                                        break;
                                    case 1:
                                        focusCol = "col2";
                                        break;
                                    case 2:
                                        focusCol = "col3";
                                        break;
                                    case 3:
                                        focusCol = "col4";
                                        break;
                                    default:
                                        break;
                                }
                                const focusValue = (event as CustomEvent).detail.searchedText;
                                handleFilterChange(focusCol, focusValue)
                            }}
                            onTableInputChange={(event:Event)=>{
                                //console.log(event)
                                const focusCol = (event as CustomEvent).detail.col;
                                const focusValue = (event as CustomEvent).detail.value;
                                //console.log(focusCol + " - " + focusValue)
                                //handleFilterChange(focusCol, focusValue)
                            }}
                            onColumnSorting={(event:Event)=>{
                                //console.log((event as CustomEvent).detail.columnID) 
                                switch((event as CustomEvent).detail.columnID){
                                case "col7":
                                    handleSortColumn5()
                                    break;
                                default:  
                                    break;
                                }
                            }}
                            onResetSearch={(event:Event)=>{
                            //console.log('cliccata cella: ' + (event as CustomEvent).detail.cells);
                            switch ((event as CustomEvent).detail.cells) {
                                case 0:
                                    handleFilterChange("col1", "");
                                    break;
                                case 1:
                                    handleFilterChange("col2", "");
                                    break;
                                case 2:
                                    handleFilterChange("col3", "");
                                    break;
                                case 3:
                                    handleFilterChange("col4", "");
                                    break;
                                default:
                                    break;
                            }
                        }}
                        /> 
                    }

                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "24px" }}>
                            <DsBadge notificationStatus={getBadgeStatus(BadgeStatus.APPROVED)} isSmall={true} />
                            <span className="legendaLabel--contract">
                                {t('transporter.transporterList.tableLegend.0') /*Approvato*/ }
                            </span>
                            <DsBadge notificationStatus={getBadgeStatus(BadgeStatus.TOAPPROVE)} isSmall={true} />
                            <span className="legendaLabel--contract">
                                {t('transporter.transporterList.tableLegend.1') /*In attesa*/}
                            </span>
                            <DsBadge notificationStatus={getBadgeStatus(BadgeStatus.EXPIRED)} isSmall={true} />
                            <span className="legendaLabel--contract">
                                {t('transporter.transporterList.tableLegend.2') /*Non approvato / Documento scaduto*/ }
                            </span>
                        </div>
                        </div>

                </>
                :
                <NoDataFound
                    title={t('transporter.transporterList.noData.title')}//"Non sono presenti trasportatori"
                    subTitle={t('transporter.transporterList.noData.subTitle')}//"Inserisci un nuovo trasportatore dal bottone predisposto"
                />
            }

        </div>
    );



}

export default TransportList;